// Manual SKU -> weight (grams) + box dimensions (cm).
// Mirror of scripts/product-dimensions-map.json — keep both in sync.
// Used by orderCreator to stamp item weight/dimensions on NEW orders.
export const SKU_DIMENSIONS = {
    HP5:  { weight_grams: 490,  boxLength: 18, boxBreadth: 10, boxHeight: 7 },
    '35': { weight_grams: 200,  boxLength: 15, boxBreadth: 6,  boxHeight: 6 },
    H1:   { weight_grams: 200,  boxLength: 15, boxBreadth: 6,  boxHeight: 6 },
    '36': { weight_grams: 400,  boxLength: 18, boxBreadth: 8,  boxHeight: 8 },
    '1':  { weight_grams: 490,  boxLength: 18, boxBreadth: 10, boxHeight: 7 },
    HP1:  { weight_grams: 490,  boxLength: 18, boxBreadth: 10, boxHeight: 7 },
    C1:   { weight_grams: 490,  boxLength: 18, boxBreadth: 10, boxHeight: 7 },
    HP3:  { weight_grams: 1470, boxLength: 18, boxBreadth: 15, boxHeight: 10 },
    C5:   { weight_grams: 2450, boxLength: 20, boxBreadth: 18, boxHeight: 12 },
    HP11: { weight_grams: 5390, boxLength: 26, boxBreadth: 22, boxHeight: 16 },
    '3':  { weight_grams: 5390, boxLength: 26, boxBreadth: 22, boxHeight: 16 },
};

/**
 * Box dimensions for a SKU.
 *
 * ⚠️ The `weight_grams` in this file is NOT authoritative and must not be used to price a
 * parcel — the PRODUCT MASTER is the only weight source. These entries have drifted (HP11
 * says 5390 g where the master says 1000 g), and a stale file silently overruling the
 * Products screen is how real parcels were mispriced.
 */
export const dimsForSku = (sku) => SKU_DIMENSIONS[String(sku || '').trim().toUpperCase()] || null;
